import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { X } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { language } = useLanguage();

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      // Show banner after a short delay
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setIsVisible(false);
  };

  const declineCookies = () => {
    localStorage.setItem('cookie_consent', 'declined');
    setIsVisible(false);
  };

  const content = {
    pl: {
      text: "Ta strona używa plików cookies w celu zapewnienia najlepszej jakości usług. Kontynuując przeglądanie strony, zgadzasz się na ich użycie.",
      accept: "Akceptuję",
      decline: "Odrzuć",
      moreInfo: "Więcej informacji"
    },
    ru: {
      text: "Этот сайт использует файлы cookies для обеспечения наилучшего качества услуг. Продолжая просмотр сайта, вы соглашаетесь на их использование.",
      accept: "Принимаю",
      decline: "Отклонить",
      moreInfo: "Подробнее"
    }
  };

  const t = content[language] || content.pl;

  if (!isVisible) return null;

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-[#111111] border-t border-zinc-800 shadow-2xl"
      data-testid="cookie-banner"
    >
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex-1 text-sm text-zinc-300">
          <p>
            {t.text}{' '}
            <Link to="/privacy-policy" className="text-yellow-400 hover:underline">
              {t.moreInfo}
            </Link>
          </p>
        </div>
        
        <div className="flex items-center gap-3">
          <button
            onClick={declineCookies}
            className="px-4 py-2 text-sm font-bold uppercase tracking-wider text-zinc-400 border border-zinc-700 hover:border-zinc-500 hover:text-white transition-colors"
            data-testid="cookie-decline"
          >
            {t.decline}
          </button>
          <button
            onClick={acceptCookies}
            className="px-6 py-2 text-sm font-bold uppercase tracking-wider bg-yellow-400 text-black border border-yellow-400 hover:bg-yellow-300 transition-colors"
            data-testid="cookie-accept"
          >
            {t.accept}
          </button>
          <button
            onClick={declineCookies}
            className="p-2 text-zinc-500 hover:text-white transition-colors sm:hidden"
            aria-label="Close"
          >
            <X size={20} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
